export const stateFieldMappings = {
  TOTAL_HEADCOUNT: 'total_headcount',
  CURRENT_ARR: 'current_arr',
  FCF_MARGIN: 'fcf_margin',
  YOY_ARR: 'yoy_arr'
} as const;

export const CalculateFieldNames = {
  ...stateFieldMappings,
  NET_NEW_ARR: 'net_new_arr',
  BOP_ARR: 'bop_arr',
  EOP_ARR: 'eop_arr',
  EXPANSION_ARR: 'expansion_arr',
  GROSS_CHURN_ARR: 'gross_churn_arr',
  NEW_LOGO_ARR: 'new_logo_arr',
  ARR_PER_FTE: 'arr_per_fte',
  RULE_OF_40: 'rule_of_40',
  NEW_LOGO_ARR_OF_GROSS_NEW: 'new_logo_arr_of_gross_new',
  EXPANSION_ARR_OF_GROSS_NEW: 'expansion_arr_of_gross_new',
  QUICK_RATIO: 'quick_ratio',
  NET_DOLLAR_RETENTION: 'net_dollar_retention',
  GROSS_DOLLAR_RETENTION: 'gross_dollar_retention',
  BURN_MULTIPLE: 'burn_multiple',
  FCF: 'fcf',
  NET_MAGIC_NUMBER: 'net_magic_number',
  SM_OPEX: 'sm_opex',
  OPEX_PER_FTE: 'opex_per_fte',
  TOTAL_OPEX: 'total_opex',
  GA_HEADCOUNT: 'ga_headcount',
  SM_HEADCOUNT: 'sm_headcount',
  RD_HEADCOUNT: 'rd_headcount',
  GA_HEADCOUNT_PERCENT: 'ga_headcount_percent',
  SM_HEADCOUNT_PERCENT: 'sm_headcount_percent',
  RD_HEADCOUNT_PERCENT: 'rd_headcount_percent',
  AVG_DEAL_SIZE: 'avg_deal_size',
  NEW_LOGO_VELOCITY: 'new_logo_velocity',
  CAC_PAYBACK_PERIOD: 'cac_payback_period',
  GROSS_MARGIN: 'gross_margin',
  GA_PERCENT_OPEX: 'ga_percent_opex',
  SM_PERCENT_OPEX: 'sm_percent_opex',
  RD_PERCENT_OPEX: 'rd_percent_opex',
  ANNUAL_REVENUE: 'annual_revenue',
  GA_ABSOLUTE_OPEX: 'ga_absolute_opex',
  SM_ABSOLUTE_OPEX: 'sm_absolute_opex',
  RD_ABSOLUTE_OPEX: 'rd_absolute_opex'
} as const;
